// i18n area 'backups' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.fi-FI.meta.json.
import type { enUS } from './backups'

export const fiFI: typeof enUS = {
  ckpt: {
    contents: 'Ottaa vastaan',
    contentsHint:
      'Mitä tänne saa laskeutua. ”Checkpointit” on klusterin kokoonpano, ”Datavarmuuskopiot” ovat virtuaalikoneiden: kaksi lukutapaa täydentävät toisiaan, yksi kohde voi ottaa vastaan molemmat.',
    content: { checkpoints: 'Checkpointit', backups: 'Datavarmuuskopiot' },
    destinationsTitle: 'Varmuuskopiokohteet',
    checkpointsTitle: 'Checkpointit',
    restoreTitle: 'Palautus',
    addDestination: 'Lisää kohde',
    addDestinationTitle: 'Lisää varmuuskopiokohde',
    editDestinationTitle: 'Muokkaa kohdetta',
    storage: 'Storage',
    storageHint:
      'Dir-tyyppinen storage (dir/NFS/CIFS/CephFS) — artefaktit ovat tavallisia tiedostoja alustan namespacen alla.',
    schedule: 'Aikataulu',
    scheduleNone: 'Vain manuaalinen',
    scheduleHourly: 'Tunneittain',
    scheduleDaily: 'Päivittäin',
    scheduleWeekly: 'Viikoittain',
    scheduleHour: 'Tunti',
    scheduleWeekday: 'Päivä',
    scheduleHint:
      'Aikataulutetuilla checkpointeilla ei ole operaattoria näppäilemässä masterpassia: keystoren salaisuudet paketoidaan placeholdereina.',
    retention: 'Retention',
    retentionHint:
      'Montako aikataulutettua checkpointia pidetään — sweeper poistaa vanhimmat lukumäärän yli menevät. Manuaalisia ja palautusta edeltäviä checkpointeja ei koskaan poisteta.',
    paused: 'Tauolla',
    pausedHint:
      'Operaattorin blackout: niin kauan kuin tauko kestää, tähän kohteeseen ei aikatauluteta eikä karsita mitään — niin datapolicyt kuin checkpointit. Käynnissä oleviin ajoihin ei kosketa koskaan.',
    orphanRuns: '{n} orpoa ajoa',
    orphanRunsHint:
      'Ajastettuja ajoja policyista, joita ei enää ole tässä kohteessa: mikään retention ei hallitse niitä — ei koskaan laskettuja eikä karsittuja — ja vain käsi poistaa ne. tvirt diagnose -linssi ”backups” nimeää poistetut policyt.',
    rescan: 'Adoptoi artefaktit uudelleen',
    rescanTitle: 'Kohteen {name} artefaktien uudelleenadoptio',
    rescanHint:
      'Rakentaa varmuuskopioluettelon (VM/CT/App) uudelleen kohteessa olevien artefaktien manifesteista. Olemassa oleviin riveihin ei koskaan kosketa; tuntemattomien käytäntöjen kopiot jäävät orvoiksi (ei koskaan karsita automaattisesti). Siirto bootstrap-palautuksen jälkeen.',
    masterpassDrWarning:
      'Katastrofiskenaario: LUKS-levyt palaavat VAIN checkpointista, jossa on masterpass. Ajastetut checkpointit pakkaavat paikkamerkkejä — ota säännöllisesti manuaalinen checkpoint masterpassilla.',
    policy: {
      title: 'Datavarmuuskopioiden policyt',
      hint: 'Nimettyjä policyja: mitkä objektit (kind, tagit, scopet), kuinka usein, milloin ajo saa käynnistyä ja montako kopiota pidetään. Värväyksen ele jää objektin omistajalle: tagit annetaan sen omassa scopessa.',
      add: 'Lisää policy',
      column: 'Datapolicyt',
      name: 'Nimi',
      nameHint:
        'Policyn nimilappu, yksilöllinen kohteen sisällä. Ajot seuraavat policyn pysyvää id:tä: uudelleennimeäminen on ilmaista; poistaminen tekee sen ajoista orpoja (ei enää laskettuja eikä karsittuja).',
      kindLocked: 'Olemassa olevan policyn objektiperhettä ei voi vaihtaa: luo uusi policy.',
      kindLabel: 'Objektit',
      kind: { vm: 'Virtuaalikoneet', ct: 'Containerit', app: 'Sovellukset' },
      tags: 'Tagivalitsin',
      tagsHint:
        'Pilkuin erotellut tag=arvo-parit, AND-ehdolla. Tyhjät tagit ja scopet eivät valitse mitään — eivät koskaan ”kaikkea”.',
      scopes: 'Scopet',
      scopesHint: 'Scope-polut (alipuut), pilkuin eroteltuina, keskenään OR-ehdolla.',
      windowStart: 'Ikkuna alkaen',
      windowEnd: 'Ikkuna asti',
      windowHint:
        'Suoritusikkuna (HH:MM, paikallista aikaa; loppua myöhempi alku ylittää keskiyön). Se hallitsee vain KÄYNNISTYSTÄ: ajoa, joka venyy sen yli, ei koskaan tapeta.',
      mode: 'Tila',
      modeHint:
        'Inkrementaalinen ratsastaa sarjaperheellä; katkennut sarja degradoituu fulliksi, kerrottu päiväkirjassa.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementaalinen',
      requireQuiesce: 'Vaadi quiesce (guest agent)',
      paused: 'Policy tauolla',
      retentionNone: 'Pidä kaikki',
      retentionCount: 'Lukumäärä',
      retentionGfs: 'GFS-renkaat',
      gfs: {
        keepLast: 'Viimeisimmät',
        daily: 'Päivittäiset',
        weekly: 'Viikoittaiset',
        monthly: 'Kuukausittaiset',
        yearly: 'Vuosittaiset'
      },
      gfsHint:
        'Kullekin renkaalle pidetään kunkin viimeisen N jakson uusin varmuuskopio. Pidetty varmuuskopio pitää koko ketjunsa elossa — koskaan ei jää pohjaa orpoineen.',
      lastRun: 'Viimeisin ajo',
      neverRan: 'ei koskaan ajettu'
    },
    lastCheckpoint: 'Viimeisin checkpoint',
    neverRun: 'Ei koskaan luotu',
    createNow: 'Luo checkpoint',
    createNowTitle: 'Luo checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Suojaa keystoren salaiset arvot (argon2id → AES-256-GCM, arvo kerrallaan). Sitä ei koskaan tallenneta: säilytä se — ilman sitä palautus tuottaa placeholdereita oikeiden salaisuuksien tilalle.',
    masterpassEmptyHint: 'Jätä tyhjäksi paketoidaksesi eksplisiittiset placeholderit salaisuuksien tilalle.',
    createStarted: 'Checkpoint käynnissä…',
    destinationInUseError: "'{name}' sisältää yhä checkpointeja — poista ne ensin.",
    origin: 'Alkuperä',
    originManual: 'manuaalinen',
    originSchedule: 'aikataulutettu',
    originPreRestore: 'palautusta edeltävä',
    originPreChange: 'ennen muutosta',
    preChangeRetention: 'Muutosta edeltävät checkpointit',
    preChangeRetentionHint:
      'Tyhjä = pois käytöstä. Ensimmäinen konfiguraatiokirjoitus hiljaisen jakson jälkeen jäädyttää tähän edeltävän tilan (alkuperä ”ennen muutosta”); uusimmat säilytetään lukumäärään asti — oma, karsittava retentio.',
    diffTitle: 'Muutosten esikatselu',
    diffFailed: 'Esikatselu epäonnistui',
    diffRetry: 'Yritä uudelleen',
    diffCounts: '{changed} muuttuu · {missing} luodaan · {extra} ylimääräistä · {equal} identtistä',
    diffChanged: 'muuttuu',
    diffMissing: 'luotaisiin',
    diffExtra: 'poistettaisiin',
    diffJsonb: 'jsonb-viittauksia ei voi todentaa ennen käyttöönottoa',
    diffSecret: 'sinetöidyt kentät, ei vertailukelpoisia',
    diffMore: 'vielä {n}…',
    diffNeeded: 'Käynnistys aktivoituu, kun esikatselu vastaa valintaa.',
    phase: 'Tila',
    phaseRunning: 'käynnissä',
    phaseComplete: 'valmis',
    phaseError: 'virhe',
    secrets: 'Salaisuudet',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholderit',
    size: 'Koko',
    created: 'Luotu',
    destination: 'Kohde',
    download: 'Lataa .tvbk',
    deleteCheckpoint: 'Poista checkpoint',
    noCheckpoints: 'Ei checkpointeja — luo sellainen jostakin kohteesta.',
    families: 'Perheet',
    generation: 'Sukupolvi',
    completedAt: 'Valmistui',
    errorDetail: 'Virheen tiedot',
    manifest: 'Manifest',
    restoreHint: 'Lataa .tvbk-artefakti: explorer näyttää, mitä se sisältää — valitse sitten, mitä palautat ja miten.',
    uploadFile: 'Lataa .tvbk-tiedosto',
    uploading: 'Ladataan…',
    uploadFailed: 'Artefaktia ei voitu avata',
    explorerTitle: 'Checkpointin sisältö',
    checkpointFrom: 'Klusterin {cluster} checkpoint, luotu {when} ({origin}, sukupolvi {generation})',
    otherCluster:
      'Tämä checkpoint on peräisin TOISESTA klusterista ({cluster}) — klusterien välinen palautus tulee tulevassa roundissa.',
    encrypted: 'salattu',
    objectsCount: '{n} objektia',
    mode: 'Moodi',
    modeMerge: 'Merge — täsmäyttää: valittujen upsert, ei poista mitään',
    modeOverwrite:
      'Overwrite — checkpoint voittaa: kokonaan valittu perhe korvataan kokonaisuudessaan (nykyiset rivit, jotka puuttuvat checkpointista, kuolevat)',
    restoreMasterpassHint:
      'Masterpass, jolla checkpoint luotiin. Ilman sitä salatut salaisuudet palautetaan eksplisiittisinä placeholdereina.',
    checkMasterpass: 'Tarkista',
    masterpassOk: 'Masterpass oikein',
    masterpassWrong: 'Masterpass väärin',
    parachuteDestination: 'Laskuvarjokohde',
    parachuteHint:
      'Ennen kuin task koskee yhteenkään riviin, se luo tänne automaattisen palautusta edeltävän checkpointin.',
    summaryTitle: 'Mitä tapahtuu',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'koko perhe',
    summaryObjects: '{n} valittua objektia',
    confirmHint:
      'Kirjoita klusterin nimi ({name}) vahvistukseksi — palautus kirjoittaa julistetun konfiguraation uusiksi.',
    confirmField: 'Klusterin nimi',
    startRestore: 'Palauta',
    restoreRunning: 'Palautus käynnissä…',
    restoreDone: 'Palautus valmis — reconcilerit konvergoivat uuteen julistukseen.',
    restoreFailed: 'Palautus epäonnistui',
    discard: 'Hylkää',
    selectionEmpty: 'Valitse vähintään yksi perhe tai objekti.'
  },

  backup: {
    intro: {
      title: 'VM- ja container-datan backup',
      subtitle: 'Rakennuspalikat, joita ulkoinen backup-ohjelmisto käyttää',
      whatItIs:
        'TVirt tarjoaa neljä primitiiviä: quiesced-snapshotit, levykohtainen change tracking, vain luettava NBD-export ja konfiguraation export. Niitä ohjaavat Veeam, Bacula, Acronis ja kumppanit.',
      whatItIsNot:
        'TVirt ei ole backup-tuote: se ei aikatauluta mitään, ei sovella retentiota eikä säilytä mitään arkistoa datastasi. Retentio, katalogit ja palautuspolitiikat kuuluvat ohjelmistolle, jota jo käytät.'
    },
    cbt: {
      title: 'Muutosseuranta',
      colVm: 'VM',
      colDisk: 'Levy',
      colState: 'Tila',
      colBitmaps: 'Bittikartat',
      colObservedAt: 'Havaittu',
      colChangeId: 'Change-ID',
      colMechanic: 'Mekanismi',
      stateActive: 'Käytössä',
      stateInactive: 'Pois',
      stateInconsistent: 'Epäjohdonmukainen — seuraavan varmuuskopion on oltava täysi',
      stateBroken: 'Ketju katkennut — poista käytöstä ja ota käyttöön uutena ketjuna',
      stateSnapshots: 'Aina päällä — delta tilannekuvien välillä',
      stateUnavailable: 'Ei saatavilla tällä levyllä',
      mechanic: {
        'qcow2-bitmap': 'qcow2-bittikartta',
        'rbd-snapdiff': 'Ceph-tilannekuvien diff',
        'lvm-thin-delta': 'Thin pool -delta',
        none: 'Ei mitään'
      },
      empty:
        'Ei VM-levyjä. Muutosseuranta luetaan levykohtaisesti: ota se käyttöön qcow2-levyllä tai ota tilannekuvia rbd/SAN:lla.',
      chainBroken: 'Ketju katkennut',
      chainBrokenText:
        'Katkaissut {reason}: {bitmaps}. Poista bittikartta käytöstä (ketju on menetetty, seuraava varmuuskopio on täysi) ja ota se käyttöön uutena ketjuna.',
      lineages: 'Epookit',
      epochFrozen: 'jäädytetty tilannekuvaan {snapshot}',
      epochLost: 'menetetty ({cause})',
      epochRecording: 'tallentaa kärjessä',
      milestones: 'Virstanpylväät (tilannekuvat)',
      enable: 'Ota muutosseuranta käyttöön',
      disable: 'Poista käytöstä',
      reset: 'Nollaa',
      changedAreas: 'Muuttuneet alueet',
      denied: 'Sinulta puuttuu oikeus tähän VM:ään',
      enableTitle: 'Ota muutosseuranta käyttöön',
      disableTitle: 'Poista muutosseuranta käytöstä',
      resetTitle: 'Nollaa bittikartta',
      areasTitle: 'Muuttuneet alueet',
      bitmapName: 'Bittikartan nimi',
      bitmapNameHint: 'Oma nimesi: tvirt- ja tvbk- kuuluvat alustalle',
      granularity: 'Tarkkuus (tavua)',
      granularityHint: 'Kahden potenssi; oletus 65536',
      bitmap: 'Bittikartta',
      disableHint: 'Poistaa bittikartan ja koko sen epookkihistorian: seuraavan varmuuskopion on oltava täysi.',
      resetHint: 'Tyhjentää bittikartan — uusi perusta: nollausta vanhempaa change-ID:tä ei voi enää yhdistää.',
      areasFrom: 'Tilannekuvasta',
      areasTo: 'Tilannekuvaan',
      areasRun: 'Laske',
      areasResult: '{count} muuttunutta aluetta, {bytes}',
      areasEmpty: 'Ei muuttuneita alueita kahden tilannekuvan välillä',
      areasZero: 'nollia',
      areasMore: 'näytetään ensimmäiset {shown}/{count}',
      submit: 'Vahvista',
      error: 'Muutosseurannan toiminto epäonnistui'
    },
    exports: {
      title: 'Avoimet NBD-viennit',
      colVm: 'VM',
      colDisk: 'Levy',
      colSnapshot: 'Tilannekuva',
      colBitmap: 'Bittikartta',
      colPhase: 'Vaihe',
      colNode: 'Solmu',
      colEndpoint: 'Päätepiste',
      colExpires: 'Vanhenee',
      colCreated: 'Avattu',
      colError: 'Virhe',
      phase: {
        preparing: 'Valmistellaan',
        ready: 'Valmis',
        closed: 'Suljettu',
        error: 'Epäonnistui'
      },
      expiresIn: '{minutes} min kuluttua',
      expired: 'vanhentunut',
      empty: 'Ei vientejä. Lukuistunto tarjoaa yhden levyn yhdessä tilannevedoksessa NBD-asiakkaalle; kirjoitusistunto täyttää pysäytetyn VM:n koskemattoman levyn. Molemmat kuolevat vanhentuessaan.',
      endpointHint: 'TLS klusterin CA:lla; viennin nimi on lippu — se kuolee istunnon mukana',
      closeDenied: 'Sinulta puuttuu oikeus sulkea tämän VM:n vientejä',
      open: 'Avaa NBD-vienti',
      openTitle: 'Avaa NBD-vienti',
      openDisk: 'Levy',
      openBitmap: 'Bittikartta (valinnainen)',
      openBitmapHint:
        'Julkaisee bittikartan tähän tilannekuvaan jäädytetyn epookin muuttuneiden extentien meta-contextina (vain qcow2-levyt)',
      openTtl: 'Kesto (minuuttia)',
      openSubmit: 'Avaa',
      openError: 'Vientiä ei voitu avata',
      colMode: 'Tila',
      mode: {
        read: 'Luku',
        write: 'Kirjoitus'
      },
      caCertificate: 'Klusterin CA',
      caCopy: 'Kopioi PEM',
      caDownload: 'Lataa ca-cert.pem',
      caHint: 'Kirjoita PEM tiedostoon ca-cert.pem yksityiseen hakemistoon ja yhdistä osoitteella nbds://…?tls-certificates=<hakemisto> (nbdcopy, nbdinfo) tai --object tls-creds-x509,dir=<hakemisto>,endpoint=client (qemu-img)',
      caAbsent: 'Istunto ei kanna CA:ta (ei PKI:tä)',
      openWrite: 'Avaa kirjoitusvienti',
      openWriteTitle: 'Avaa kirjoitusvienti',
      openWriteIntro: 'Levyn on oltava koskematon: syntynyt tyhjänä, ei koskaan kirjoitettu, ilman tilannevedosta; VM pysäytetty. Palautus TÄYTTÄÄ levyn, se ei korjaa sitä. Istunnon ollessa auki VM ei käynnisty, ei ota tilannevedosta, ei kloonaudu eikä levy siirry.',
      openWriteSubmit: 'Avaa',
      openWriteError: 'Kirjoitusvientiä ei voitu avata',
      openWriteDenied: 'Sinulta puuttuu vm.restore.data tällä VM:llä',
      openWriteStopped: 'Pysäytä VM avataksesi kirjoitusviennin',
      fromDescription: 'Luo VM kuvauksesta',
      fromDescriptionTitle: 'Luo VM kuvauksesta',
      fromDescriptionIntro: 'export-vm-meta:n kuvaus palaa pysäytettynä VM:nä, jonka levyt ovat tyhjiä ja kuvatun geometrian mukaisia — valmiina kirjoitusvienteihin levy kerrallaan. Tavut eivät kulje tästä: ne kantaa restore-disk (CLI) tai varmuuskopiotuotteen NBD-asiakas.',
      fromDescriptionDoc: 'Kuvaus (JSON)',
      fromDescriptionDocHint: 'Liitä export-vm-meta:n dokumentti tai valitse tiedosto',
      fromDescriptionFile: 'Valitse tiedosto…',
      fromDescriptionInvalid: 'Teksti ei ole JSON-dokumentti',
      fromDescriptionName: 'Uuden VM:n nimi',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Kotiscopesi',
      fromDescriptionStorage: 'Levyjen tallennustila',
      fromDescriptionStorageHint: 'Jokainen levy syntyy tänne tallennustilan oletusmuodossa',
      fromDescriptionMetadataStorage: 'Metatietojen tallennustila',
      fromDescriptionSameAsStorage: 'Sama kuin levyillä',
      fromDescriptionBridge: 'Silta',
      fromDescriptionBridgeHint: 'Ilman siltaa tai verkkoa VM syntyy ilman verkkokortteja',
      fromDescriptionNetwork: 'Looginen verkko (fabric/verkko)',
      fromDescriptionSubmit: 'Luo',
      fromDescriptionError: 'VM:ää ei voitu luoda',
      fromDescriptionDone: 'VM luotu: {name}',
      fromDescriptionOpen: 'Avaa VM',
      fromDescriptionDenied: 'Sinulta puuttuu vm.create',
      fromDescriptionStillRunning: 'Luonti on yhä käynnissä: odotetaan edelleen'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Virtuaalikoneiden datavarmuuskopiot',
      titleOnVm: 'Datavarmuuskopiot',
      empty:
        'Ei varmuuskopioita. Varmuuskopio vie levyt, UEFI-varstoren ja vTPM:n tilan kohteeseen, ja jää eloon virtuaalikoneen jälkeen.',
      colVm: 'VM',
      colCreated: 'Otettu',
      colPhase: 'Tulos',
      colDestination: 'Kohde',
      colContains: 'Sisältö',
      colSize: 'Koko',
      colOrigin: 'Alkuperä',
      colMode: 'Tyyppi',
      retentionChip: 'Säilytys',
      retentionHint:
        'Kohteen säilytys voi poistaa tämän varmuuskopion kysymättä: se syntyi ajastuksesta. Käsin tehtyjä varmuuskopioita ei lakaista koskaan.',
      policyRemoved: 'Policy poistettu: {name}',
      policyRemovedHint:
        'Tämän backupin ajastanut policy ei ole enää olemassa: mikään retention ei hallitse sitä (ei koskaan karsita automaattisesti) — poista se käsin, kun sitä ei enää tarvita.',
      phase: {
        running: 'Käynnissä',
        complete: 'Valmis',
        error: 'Epäonnistui'
      },
      origin: {
        manual: 'Käsin',
        schedule: 'Ajastettu'
      },
      mode: {
        full: 'Täysi',
        incremental: 'Lisäävä'
      },
      contains: {
        disks: 'Levyt',
        varstore: 'UEFI-varstore',
        vtpm: 'vTPM:n tila',
        snapshots: 'Tilannekuvat'
      },
      vmState: {
        stopped: 'VM sammutettu',
        running: 'VM käynnissä (kuuma)'
      },
      artifactClass: { metadata: 'Metatiedot', data: 'Data', secret: 'Salaisuus' },
      detail: {
        tabOverview: 'Yhteenveto',
        tabArtefact: 'Artefakti',
        id: 'Tunniste',
        scope: 'Näkyvyysalue',
        vmState: 'VM:n tila kopioinnin hetkellä',
        pointInTime: 'Datan hetki',
        completedAt: 'Päättyi',
        node: 'Kopioinut solmu',
        error: 'Virhe',
        path: 'Hakemisto tallennustilassa',
        checksum: 'manifestin sha256',
        secretsExposed: 'Arkaluonteista aineistoa selkokielisenä',
        secretsExposedYes: 'Kyllä — kohde ei salaa',
        secretsExposedNo: 'Ei',
        baseBackup: 'Perusvarmuuskopio',
        tabManifest: 'Manifesti',
        manifestHint:
          'Artefaktin selkokielinen hakemisto: yksi tiedosto riviä kohti sha256-tiivisteineen. Kansio todennetaan ilman TVirtiä — qemu-img, tar ja jq riittävät.',
        manifestEmpty: 'Manifesti ei luettele tiedostoja.',
        manifestError: 'Manifestia ei voi lukea',
        colEntry: 'Tiedosto',
        colClass: 'Luokka',
        colSha: 'sha256'
      },
      create: {
        action: 'Varmuuskopioi nyt',
        title: 'Varmuuskopioi nyt',
        submit: 'Käynnistä varmuuskopiointi',
        destination: 'Kohde',
        destinationHint: 'Vain kohteet, jotka ottavat vastaan varmuuskopioita.',
        noDestinations:
          'Mikään kohde ei ota vastaan varmuuskopioita: luo sellainen kohdassa Järjestelmä → Checkpointit.',
        contentsHint:
          'Mukaan lähtevät kaikki levyt, UEFI-varstore ja vTPM:n tila. Kaksi jälkimmäistä ovat ydin: sinetöidyn vieraan on käynnistyttävä uudelleen.',
        error: 'Varmuuskopiointi ei käynnistynyt',
        stillRunning: 'Varmuuskopiointi on yhä käynnissä — kopiointi jatkuu, vaikka suljet.',
        vmRunning:
          'Virtuaalikone on {phase}: varmuuskopio vaatii vakaan VM:n — sammutetun kylmää kopiota varten, käynnissä olevan kuumaa varten.'
      },
      restore: {
        action: 'Palauta',
        title: 'Palauta',
        intro: 'Palautus on peruuttamaton. Valitse, minne data palaa: uuteen koneeseen vai alkuperäisen päälle.',
        modeNewVm: 'Palauta UUTEEN virtuaalikoneeseen',
        modeNewVmHint:
          'Ei koske mihinkään olemassa olevaan — tällä vaihtoehdolla varmuuskopio todennetaan. Uusi tunniste ja vasta lyödyt MAC-osoitteet.',
        modeOver: 'Korvaa alkuperäinen virtuaalikone',
        modeOverHint: 'Tuhoaa kohde-VM:n nykyisen datan, ilman paluuta. Virtuaalikoneen on oltava sammutettu.',
        newName: 'Uuden VM:n nimi',
        newNameHint: 'Sen on oltava vapaa kohdealueella.',
        storage: 'Levyjen tallennustila',
        storageHint: 'Pakollinen: manifesti kirjaa levyn koon ja muodon, ei koskaan tallennustilaa jossa se sijaitsi.',
        metadataStorage: 'Varstoren ja vTPM:n tallennustila',
        metadataStorageHint: 'Minne UEFI-identiteetti ja vTPM:n tila laskeutuvat.',
        sameAsStorage: 'Sama kuin levyillä',
        bridge: 'Isännän bridge',
        bridgeHint:
          'Jokainen kirjattu verkkokortti palaa tälle bridgelle uudella MAC-osoitteella. Tyhjäksi jätettynä VM syntyy ilman kortteja — turvallisempi oletus.',
        overwriteTitle: 'Olet korvaamassa tämän virtuaalikoneen',
        overwriteName: 'Nimi',
        overwriteId: 'Tunniste',
        overwriteDisks: 'Levyt jotka kirjoitetaan yli',
        overwriteNoDisks: 'Ei levyjä.',
        overwriteKeeps:
          'Koskematta jäävät tunniste, nimi, näkyvyysalue, verkkokortit ja MAC-osoitteet: varmuuskopio on DATA, konfiguraatio on checkpoint.',
        confirmField: 'VM:n nimi',
        confirmHint: 'Kirjoita {name} vahvistaaksesi.',
        targetLoading: 'Luetaan kohde-VM:ää…',
        targetRunning:
          'Kohde-VM on {phase}: palautus kirjoittaa tavut vieraan alta uusiksi, joten se vaatii sen sammutetuksi.',
        targetGone: 'Alkuperäistä virtuaalikonetta ei voi enää lukea: palautus uuteen VM:ään on yhä käytettävissä.',
        onlyComplete: 'Varmuuskopio on {phase}: vain valmis varmuuskopio voi palauttaa.',
        submitNewVm: 'Palauta uuteen virtuaalikoneeseen',
        submitOver: 'Korvaa',
        error: 'Palautus ei käynnistynyt',
        stillRunning: 'Palautus on yhä käynnissä — kokonaisten levyjen kopiointi vie aikaa.'
      }
    },
    guest: {
      title: {
        ct: 'Konttien datavarmuuskopiot',
        app: 'Appien datavarmuuskopiot'
      },
      tabTitle: 'Varmuuskopiot',
      empty: 'Ei varmuuskopioita. Varmuuskopio kopioi pysyvät tiedot kohteeseen ja elää objektiaan pidempään.',
      colSubject: {
        ct: 'Kontti',
        app: 'Appi'
      },
      colCreated: 'Otettu',
      colPhase: 'Tulos',
      colDestination: 'Kohde',
      colContains: 'Sisältö',
      colSize: 'Koko',
      colOrigin: 'Alkuperä',
      policyRemoved: 'Policy poistettu: {name}',
      policyRemovedHint:
        'Tämän backupin ajastanut policy ei ole enää olemassa: mikään retention ei hallitse sitä (ei koskaan karsita automaattisesti) — poista se käsin, kun sitä ei enää tarvita.',
      phase: {
        running: 'Käynnissä',
        complete: 'Valmis',
        error: 'Epäonnistui'
      },
      origin: {
        manual: 'Manuaalinen',
        schedule: 'Ajastettu'
      },
      state: {
        stopped: 'Objekti pysäytetty',
        running: 'Objekti käynnissä (jäädytetty)'
      },
      contains: {
        rootfs: 'Rootfs-puu',
        config: 'Konfiguraatio',
        volumes: 'Pysyvät taltiot',
        root: 'Pysyvä root'
      },
      artifactClass: {
        metadata: 'Metatiedot',
        data: 'Data',
        secret: 'Salainen'
      },
      create: {
        action: 'Varmuuskopioi nyt',
        title: 'Uusi varmuuskopio',
        submit: 'Käynnistä varmuuskopio',
        error: 'Varmuuskopio ei käynnistynyt',
        destination: 'Kohde',
        destinationHint: 'Vain kohteet, jotka hyväksyvät datavarmuuskopiot.',
        noDestinations: 'Mikään kohde ei hyväksy datavarmuuskopioita: lisää kohteeseen ”Datavarmuuskopiot”.',
        hint: {
          ct: 'Koko rootfs-puu matkustaa, uskollisesti (numeeriset omistajat, xattrit, ACL:t), sekä deklaroitu konfiguraatio manifestissa. Käynnissä oleva kontti JÄÄDYTETÄÄN koko pakkauksen ajaksi: crash-consistent-kopio, deklaroitu.',
          app: 'VAIN pysyvät taltiot (ja pysyvä root) matkustavat, sekä konfiguraatio manifestissa. Efemeeriset osat on suljettu pois ratifioinnilla ja manifesti nimeää ne; salaisiksi deklaroidut env-arvot eivät matkusta.'
        },
        stillRunning: 'Varmuuskopio yhä käynnissä — kokonaisten puiden pakkaaminen vie aikaa.'
      },
      detail: {
        tabOverview: 'Yleiskuva',
        tabManifest: 'Manifesti',
        id: 'Tunniste',
        scope: 'Laajuus',
        state: 'Tila kopiohetkellä',
        pointInTime: 'Tiedot hetkellä',
        completedAt: 'Valmistui',
        node: 'Kopioinut solmu',
        error: 'Virhe',
        path: 'Hakemisto tallennustilassa',
        checksum: 'manifestin sha256',
        manifestHint:
          'Artefaktin hakemisto: yksi rivi per tiedosto sha256:ineen — ilman tiivisteitä ”varmuuskopio on olemassa” on uskon asia.',
        manifestError: 'Manifestia ei voi lukea',
        manifestEmpty: 'Ei artefakteja manifestissa.',
        colEntry: 'Tiedosto',
        colClass: 'Luokka',
        colSha: 'sha256',
        excluded: 'Suljettu pois ratifioinnilla (ei matkusta)',
        secretKeys: 'Pois jätetyt salaiset env-avaimet (#307) — syötä uudelleen palautuksen jälkeen'
      },
      restore: {
        action: 'Palauta',
        title: 'Palautus',
        submit: 'Palauta',
        error: 'Palautus ei käynnistynyt',
        stillRunning: 'Palautus yhä käynnissä — kokonaisten puiden purkaminen vie aikaa.',
        onlyComplete: 'Varmuuskopio on {phase}: vain valmis varmuuskopio voi palauttaa.',
        asNew: {
          ct: 'UUTEEN konttiin — ei tuhoa mitään: ele, jolla varmuuskopio tarkistetaan',
          app: 'UUTEEN Appiin — ei tuhoa mitään: ele, jolla varmuuskopio tarkistetaan'
        },
        over: {
          ct: 'Lähdekontin PÄÄLLE — koko rootfs-puu korvataan',
          app: 'Lähde-Appin PÄÄLLE — jokaisen pysyvän taltion sisältö korvataan'
        },
        name: 'Uuden objektin nimi',
        storage: 'Tallennustila',
        storageHint: 'Minne palautetut tiedot laskeutuvat — manifesti ei koskaan kirjaa menetettyä poolia.',
        storageDeclared: 'Manifestissa deklaroidut tallennustilat',
        bridge: 'Isännän silta',
        bridgeHint:
          'Jokainen kirjattu verkkokortti palaa tälle sillalle tuoreella MAC:lla. Tyhjä = syntyy kytkemättömänä, turvallisin oletus.',
        node: 'Solmu',
        nodeHint: 'Jäsen, jolla Appi syntyy uudelleen: solmu on klusteri-identiteettiä eikä koskaan tule manifestista.',
        secretKeysWarning:
          'Salaisiksi deklaroidut env-arvot eivät matkusta varmuuskopiossa: uudelleensyntynyt kopio haluaa ne syötettyinä (task-loki nimeää avaimet).',
        overInventory: 'Olet korvaamassa tämän objektin',
        confirmType: 'Kirjoita {name} vahvistaaksesi',
        targetGone: 'Lähdeobjektia ei voi enää lukea: palautus uutena on yhä käytettävissä.',
        targetLoading: 'Luetaan kohdeobjektia…',
        targetRunning: 'Kohdeobjekti on käynnissä: palautus korvaa tavut vieraan alta ja haluaa sen pysäytetyksi.'
      }
    }
  }
}
